export const trackEvent = (name: string, customData: Record<string, unknown> = {}): void => {
    window.gtag?.("event", name, customData);
}